import VueRouter from 'vue-router';
import NewsStories from './components/news/NewsStories';

export default new VueRouter({
  routes: [
    { path: '/', component: NewsStories },
    { path: '*', redirect: '/' }
  ]
});